export const FormNames = {
    attachments: 'ATTACHMENTS',
    composeMail: 'MAILBOXSEND'
};
